import { Box, Grid2 } from '@mui/material';
import { IntegerTextField, Slider } from '@vxui/components';
import { unsignedInteger } from '@vxui/transcoder-core';
import { useFormikContext } from 'formik';
import { FC } from 'react';
import { VideoQuantity } from '../models';

type Props = {
  name: keyof VideoQuantity;
  label: string;
  disabled?: boolean;
};

export const SliderWithInput: FC<Props> = ({ name, label, disabled = false }) => {
  const { values, setFieldValue } = useFormikContext<VideoQuantity>();

  return (
    <Box>
      <Grid2 container spacing={2} sx={{ alignItems: 'center' }}>
        <Grid2 size="grow">
          <Slider
            value={typeof values[name] === 'number' ? (values[name] as number) : 0}
            onChange={(_, value) => setFieldValue(name, value)}
            aria-labelledby="input-slider"
            min={0}
            max={250}
            step={1}
            marks={false}
            disabled={disabled}
            label={label}
          />
        </Grid2>
        <Grid2 marginBottom="-30px">
          <IntegerTextField
            value={values[name]}
            size="medium"
            onChange={event => setFieldValue(name, +event.target.value)}
            onBlur={() => undefined}
            fullWidth={false}
            sx={{ width: '90px' }}
            disabled={disabled}
            {...unsignedInteger({ min: 0, max: 250 })}
          />
        </Grid2>
      </Grid2>
    </Box>
  );
};
